<template>
  <div class="component-wrapper">
    <h4 
      v-for="(t,i) in texts" 
      :key="i" 
      :style="{ fontSize:fontsize }" 
      class="newfont"
      style="text-align:center">{{ t }}</h4>
    <div class="flex">
      <div class="input-wrapper">
        <textarea 
          class="charInput newfont" 
          v-model="inputValue" 
          rows="10"
          :placeholder="placeholder" 
          :maxLength="maxLength"></textarea>
        <div class="red" v-if="valueError">Required: {{inputError}}</div>
        <div class="underline"></div>
      </div>
    </div>
    <br />
    <div class="nav-flex">
      <button class="button-std newfont" @click="backstep"><span class="material-icons">chevron_left</span>Back</button>
      <button class="button-std newfont" @click="nextstep">Next<span class="material-icons">chevron_right</span></button>
    </div>
  </div>
</template>

<script>

const verify = {
  'minLength':function(obj,value){
    if(obj.minLength >= value.length){
      return `value is not above minimum length ${obj.minLength}`
    }
    return true;
  }
}
const verifier = (arr, value) => {
  return arr.reduce((acc,cv) => {
    let key = Object.keys(cv)[0]
    if(verify[key] !== undefined){
      acc = verify[key](cv,value)
    }
    return acc;
  },true)
}
export default {
  name:"TextAreaInput",
  components:{

  },
  props:{
    verify: {
      type: Array,
      default: function(){
        return []
      }
    },
    showNext: {
      type: Boolean,
      default: true
    },
    showBack: {
      type: Boolean,
      default: true
    },
    showExit: {
      type: Boolean,
      default: false
    },
    fontsize: {
      default:"1em",
      type:String
    },
    placeholder:{
      type:String,
      default:"James",
    },
    maxLength:{
      type:String,
      default:"255",
    },
    backto: {
      type:Number
    },
    goto: {
      type:Number
    },
    for: {
      type:String,
      default:"None"
    },
    texts: {
      type:Array,
      default: function(){
        return []
      }
    }
  },
  data(){
    return {
      valueError:false,
      inputError:"",
      inputValue:"",
      errors: [],
      showConfirmPrompt: false,
      confirmMessage:""
    }
  },
  computed:{
    newpin: function(){
      return this.char1+this.char2+this.char3+this.char4
    }
  },
  watch: {

  },
  methods:{
    nextstep(){
      //localStorage.setItem('pin', JSON.stringify(this.newpin))
      console.log(this.verify);
      console.log(this.inputValue);
      let out = verifier(this.verify,this.inputValue)
      console.log(out);
      if(out === true){
        this.$emit('nextstep', {for:this.for, stepVal:this.goto, val:this.inputValue})
      } else {
        this.valueError = true;
        this.inputError = out
        setTimeout(() => {
          this.valueError = false;
          this.inputError = ""
        },9000)
      }
    },
    backstep(){
      this.$emit('backstep', {for:this.for, stepVal:this.backto})
    },
    confirmNull(){
      this.showConfirmPrompt = true;
    },
    changeInput(){

    },
  },
  beforeCreate(){
          // console.log('nothing gets created before me')
  },
  created(){

  },
  beforeMount(){

  },
  mounted(){
    document.appObserver.register('resetTextAreaInput', () => {
      this.inputValue = ""
    });

  },
  beforeUpdate(){

  },
  updated(){

  },
  beforeDestroy(){

  },
  destroyed(){

  }
}

</script>

<style scoped>
.flex {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
}
.box {
    box-sizing: border-box;
    cursor: pointer;
}
.input-wrapper {
  margin: 0px 0.5em;
}
.red {
  color:red;
}

.newfont {
  font-family:'Varela Round';
}
.button-std {
  background-color:#325DFF;
  color:#fff;
  font-weight:600;
  padding: 10px 20px;
  border-radius:9px;
  cursor:pointer;
  display:flex;
  align-items:center;
  cursor:pointer;
}
.charInput {
  font-size:3em;
  padding:10px;
}
.nav-flex {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items:center;
}

@media only screen and (max-width: 600px) {
  .charInput {
    width:95%;
  }

}
</style>
